import { render, staticRenderFns } from "./RoomTestbankList.vue?vue&type=template&id=42866bb8&"
import script from "./RoomTestbankList.vue?vue&type=script&lang=js&"
export * from "./RoomTestbankList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42866bb8')) {
      api.createRecord('42866bb8', component.options)
    } else {
      api.reload('42866bb8', component.options)
    }
    module.hot.accept("./RoomTestbankList.vue?vue&type=template&id=42866bb8&", function () {
      api.rerender('42866bb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/RoomTestbankList.vue"
export default component.exports